import axios from "axios";

// const API_URL = "http://172.20.10.7:53000/";
const API_URL = "https://tw-dev.creww.me/";
// const API_URL = "http://192.168.19.166:53000/";
// const API_URL = "http://creww.test:53000/";
// const API_URL = "http://192.168.19.144:53000/";

// const API_URL = process.env.REACT_APP_API_URL;

//Register User
const register = async (userData) => {
  const response = await axios.post(API_URL, userData);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

const login = async () => {
  const response = await axios.get(`${API_URL}user_info`);

  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data.data));
  }
  return response.data.data;
};

// Logout user
const logout = async () => {
  console.log("cookie function call");

  localStorage.removeItem("user");
  await axios
    .delete(`${API_URL}sign_out`)
    .then((res) => console.log(res, "delete res"))
    .catch((err) => console.log(err, "delete err"));
};

const authService = {
  register,
  login,
  logout,
};

export default authService;
